import { FormInput, Radar, BarChart3 } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const steps = [
  {
    icon: FormInput,
    title: "Enter your brand",
    description: "Brand name, target keyword, and website URL.",
  },
  {
    icon: Radar,
    title: "We scan ChatGPT + Google",
    description: "Real-time queries to ChatGPT and Google Search. Plus 4 technical AI-readiness checks on your site.",
  },
  {
    icon: BarChart3,
    title: "Get your score",
    description: "AI Visibility Score (0-100) with a breakdown of what's working and what's not.",
  },
];

const HowItWorks = () => {
  const ref = useScrollReveal();
  const stepsRef = useScrollReveal<HTMLDivElement>({ stagger: true });

  return (
    <section ref={ref} className="py-10 md:py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-10">
          Three steps. Real-time results.
        </h2>

        <div ref={stepsRef} className="grid md:grid-cols-3 gap-8 mb-10">
          {steps.map((step, i) => (
            <div key={step.title} className="flex flex-col items-start gap-3">
              <div className="flex items-center gap-3">
                <span className="font-mono text-sm text-muted-foreground">{i + 1}.</span>
                <div className="p-2 border-2 border-border bg-card shadow-2xs transition-all duration-200 hover:-translate-y-1 hover:shadow-sm">
                  <step.icon className="w-5 h-5 text-foreground" />
                </div>
              </div>
              <h3 className="font-semibold text-foreground text-lg">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="border-2 border-border bg-card shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md max-w-xl mx-auto py-4 px-6 text-center">
          <p className="text-sm text-muted-foreground">
            Checks for <span className="font-semibold text-foreground">GPTBot</span>, <span className="font-semibold text-foreground">ChatGPT-User</span>, <span className="font-semibold text-foreground">PerplexityBot</span>, <span className="font-semibold text-foreground">ClaudeBot</span>, and <span className="font-semibold text-foreground">Google-Extended</span> in your robots.txt, not just Googlebot.
          </p>
          <p className="text-xs text-muted-foreground mt-2">
            Also checks: llms.txt · Schema markup · sitemap.xml
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
